/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: defd34126ead
 */

import * as z from "zod";

export type Representation = {
  transformation?: Array<{ [k: string]: any }> | undefined;
};

export const Representation$zodSchema: z.ZodType<Representation> = z.object({
  transformation: z.array(z.record(z.string(), z.any())).optional().describe(
    "The transformation parameters for this representation",
  ),
});

export type StreamingProfile = {
  external_id: string;
  name: string;
  display_name?: string | null | undefined;
  predefined: boolean;
  representations?: Array<Representation> | undefined;
};

export const StreamingProfile$zodSchema: z.ZodType<StreamingProfile> = z.object(
  {
    display_name: z.string().nullable().optional().describe(
      "The display name of the streaming profile",
    ),
    external_id: z.string().describe(
      "The unique identifier of the streaming profile",
    ),
    name: z.string().describe("The name of the streaming profile"),
    predefined: z.boolean().describe(
      "Whether this is a predefined streaming profile",
    ),
    representations: z.array(z.lazy(() => Representation$zodSchema)).optional()
      .describe("The list of representations in the streaming profile"),
  },
);
